<template>
  <div class="property-page">
    <div class="content-scroll">
      <div class="content-card">
        <img :src="ossPath + 'help/user1.gif'" class="illustration" alt="用户属性">

        <div class="section">
          <h3>体力和疲劳</h3>
          <p>体力和疲劳决定用户当前的行动力以及各种行为效果，通常情况下，任何的行为都导致一定程度的体力下降和疲劳上升，尤其是与经验以及属性相关的各种工作、任务、TASK以及随机事件等。当用户的体力低到一定程度或者疲劳高到一定程度的时候，用户将不能进行很多行为。</p>
          <p>体力和疲劳可以通过使用食品类道具或者在家进行休息恢复，代价是一定数额的金钱或者经验值。</p>
        </div>

        <div class="section">
          <h3>经验和等级</h3>
          <p>游乐网——幻之大地的经验等级系统参照日式RPG设计，经验值通过日常行为得到增加（由于这个世界是和平的，因此不存在踩地雷砍人的长级方法），而每当经验值增加到一定数额时，用户的等级则会加一。</p>
          <p>等级影响用户的称号评定，大多数的高级称号都要求用户有一定的等级才可以得到。在本系统的目前版本中，等级的最高规定为99级。</p>
          <p>等级越高，达到下一等级所需要的经验值也就越高，当然，各种行为比如任务、工作等获得的奖励也随着等级的提高而增加。在本系统目前版本中，等级每提高一，达到下一等级所需要的经验值以比率为1.2的等比数列增加，而提升到99级大致需要一亿七千万经验（擦汗）。</p>
        </div>

        <div class="section">
          <h3>金钱</h3>
          <p>"钱不是万能的，但没有钱却是万万不能的"，嘿嘿，在这个世界里面当然也不例外（阴险地笑了一下）。</p>
          <p>和所有的游戏一样，在这个世界里面，金钱是极度重要的，因为几乎这个世界里面任何的行为将来（在这个版本还不是这样的）都是要付出金钱（当然不是人民币，嘿嘿）的代价的。</p>
          <p>金钱可以通过各种行为得到，根据等级和称号的不同有不同的数量，而至于怎么花钱，这个就不需要说明了吧，呵呵。</p>
        </div>

        <div class="section">
          <h3>属性</h3>
          <p>如果你玩过一个叫"美少女梦工厂"的游戏，相信你就对这样复杂的属性系统很熟悉。这个世界中的每一个人，都被赋予了衡量他综合能力（GPA?）的21种不同属性，而这些属性不同的数值也就决定了一个具体的人的能力和特点。</p>
          <p>在用户注册的时候，其中八项最基本的属性可以通过随机和附加点数的方法让用户选择不同的初始值（突出个性嘛），而其它的属性则在一开始都是一样的（人人平等嘛）。</p>
          <p>属性之间具有相生相克性（在目前版本中还不是很完善，平衡性有待调节），说白了，想让所有的属性都到最大值是非常非常非常非常难的，大家努力吧！</p>
          <p>在目前版本中，所有属性的最小值是0，最大值是100，今后可能会将最大值提高到999。</p>
        </div>
      </div>
    </div>

    <div class="bottom-fixed">
      <div class="back-link">
        <router-link :to="{name:'guideIndex'}">← 返回旅游指南</router-link>
      </div>
      <div class="page-footer">
        <div class="copyright">
          ©Copyright 2019 <a href="http://www.huanzhidadi.com" target="_blank">幻之大地</a> ALL RIGHTS RESERVED. <a href="https://beian.miit.gov.cn" target="_blank" title="豫ICP备17045248号-3">豫ICP备17045248号-3</a>
        </div>
        <div class="advice">
          抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。<br/>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    methods: {
    },
    mounted: function () {
      var _this = this;
    },
    data(){
      return {
      }
    }
  }
  
</script>
<style scoped>
.property-page {
  flex: 1;
  min-height: 0;
  max-width: 720px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 0;
}

/* ========== 正文滚动区 ========== */
.content-scroll {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 12px 12px 0;
}

.content-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 28px 30px;
  box-sizing: border-box;
}

.illustration {
  float: right;
  max-width: 200px;
  height: auto;
  margin: 0 0 16px 16px;
  border-radius: 8px;
}

.section {
  margin-bottom: 24px;
}

.section:last-child {
  margin-bottom: 0;
}

.section h3 {
  margin: 0 0 10px;
  font-size: 16px;
  color: #303133;
  padding-left: 8px;
  border-left: 3px solid #409eff;
}

.section p {
  margin: 0 0 10px;
  font-size: 15px;
  line-height: 1.9;
  color: #4a4a4a;
  text-indent: 2em;
}

.section p:last-child {
  margin-bottom: 0;
}

/* ========== 底部固定区 ========== */
.bottom-fixed {
  flex-shrink: 0;
  padding: 0 16px;
}

.back-link {
  text-align: center;
  padding: 10px 0;
}

.back-link a {
  font-size: 14px;
  color: #909399;
  text-decoration: none;
  transition: color 0.2s;
}

.back-link a:hover {
  color: #409eff;
}

.page-footer {
  text-align: center;
  padding-bottom: 16px;
}

.page-footer .copyright {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
}

.page-footer .copyright a {
  color: #909399;
  text-decoration: none;
}

.page-footer .copyright a:hover {
  color: #409eff;
}

.page-footer .advice {
  font-size: 11px;
  color: #aaa;
  line-height: 1.7;
  margin-top: 4px;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .content-scroll {
    padding: 8px 8px 0;
  }

  .content-card {
    padding: 20px 16px;
    border-radius: 10px;
  }

  .illustration {
    float: none;
    display: block;
    max-width: 160px;
    margin: 0 auto 16px;
  }

  .section {
    margin-bottom: 18px;
  }

  .section h3 {
    font-size: 15px;
  }

  .section p {
    font-size: 14px;
    line-height: 1.75;
    margin-bottom: 8px;
  }

  .back-link a {
    font-size: 13px;
  }

  .bottom-fixed {
    padding: 0 10px;
  }

  .page-footer .copyright {
    font-size: 10px;
  }

  .page-footer .advice {
    font-size: 10px;
  }
}
</style>
